/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { createSnackbarQueue, SnackbarQueue } from "@rmwc/snackbar";
import "@rmwc/snackbar/styles";
import { css } from "@emotion/react";
import Svg from "../../Image/Svg";
import useTheme from "../../../commons/hooks/use-theme";
import close from "@iconify/icons-mdi/close";
import Direction from "../../../commons/Direction";
import NotificationProvider, { NotificationDetailType } from "./commons/NotificationProvider";
import useNotificationIcon from "./use-notification-icon";

const notificationQueue = createSnackbarQueue();

const Notification: FC = ({ children }) => {
  const { getNotificationIcon } = useNotificationIcon();

  const theme = useTheme();
  const styles = css`
    div.mdc-snackbar__surface {
      direction: rtl;

      .mdc-button .mdc-button__ripple::before,
      .mdc-button .mdc-button__ripple::after {
        background-color: inherit;
      }
    }
  `;

  const notify = ({
    message,
    autoClose = true,
    timeout = 5000,
    title = "",
    onClick,
    type,
    notification = true,
    hideClose,
  }: NotificationDetailType) => {
    if (!notification) return;
    const icon = getNotificationIcon(type);
    notificationQueue.notify({
      title: (
        <div style={{ display: "flex", alignItems: "center" }}>
          {icon}
          <div style={{ marginRight: 5 }}>{title}</div>
        </div>
      ),
      body: (
        <div style={{ paddingTop: 10, paddingRight: 5, cursor: "pointer" }} onClick={() => onClick && onClick()}>
          {message}
        </div>
      ),
      dismissesOnAction: true,
      actions: !hideClose ? [{ icon: <Svg icon={close} color={theme.material.onPrimary} /> }] : [],
      timeout: autoClose ? timeout : -1,
    });
  };

  const destroy = () => {
    notificationQueue.clearAll();
  };

  return (
    <NotificationProvider onNotify={notify} onDestroy={destroy}>
      <SnackbarQueue messages={notificationQueue.messages} leading css={styles} dir={Direction.LTR} />
      {children}
    </NotificationProvider>
  );
};

export default Notification;
